import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/common';

export const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg-base)', gap: 20, textAlign: 'center', padding: 24,
    }}>
      <p style={{ fontFamily: 'var(--font-mono)', fontSize: '6rem', fontWeight: 700, color: 'var(--border-light)', lineHeight: 1 }}>404</p>
      <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '1.6rem' }}>Page Not Found</h2>
      <p style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', maxWidth: 300 }}>
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Button onClick={() => navigate('/dashboard')}>← Back to Dashboard</Button>
    </div>
  );
};
